export const queryKeyMap = {
  group: (id: string) => ['group', id],
  groups: (params?: object) =>
    ['groups', params].filter((item) => item !== undefined),
  groupTargets: (id: string) => ['groupTargets', id],
  groupProjects: (id: string) => ['groupProjects', id],
  groupProjectIds: (id?: string) =>
    ['groupProjectIds', id].filter((item) => item !== undefined),
  groupSharingInfo: (groupId: string) => ['groupSharingInfo', groupId],
};
